/* eslint-disable */
import { useState } from 'react';

export default function FunnelBox({ event, setNodes, setRefecther, refecther, funnelQuery }) {
    const [refresher, setRefresher] = useState(false);

    const FunnelNumberCol = ({ apiStrut }) => {
        function funnelNumberSet(values) {
            setNodes(nds => nds.map(node => {
                if (node.id == event.id) {
                    node.data.value.api.phone_number_col = values
                }
                return node;
            }))
            setRefecther(!refecther)
            setRefresher(!refresher)
        }
        return (
            <select className="form-select" onChange={(e) => funnelNumberSet(e.target.value)}>
                <option value="" disabled selected={!apiStrut.phone_number_col}>Select Phone Number Column</option>
                {apiStrut.Columns.map(x => (
                    <option
                        key={`col_${x.column_name}`} value={`col_${x.column_name}`}
                        selected={apiStrut.phone_number_col == `col_${x.column_name}`}
                    >
                        {x.column_name}
                    </option>
                ))}
            </select>
        );
    }

    function FunnelSet(values) {
        setNodes(nds => nds.map(node => {
            if (node.id == event.id) {
                node.data.value.api.funnelDetail = values
                node.data.value.api.Columns = funnelQuery.data.data.col_list
                node.data.value.columns = [{
                    "column": funnelQuery.data.data.col_list,
                    "type": "on_funnel",
                    "details": { "funnel_id": values }
                }]
            }
            return node;
        }))
        setRefecther(!refecther)
        setRefresher(!refresher)
    }


    const MainFun = () => {
        if (event.data.value.api.funnelDetail && event.data.value.api.funnelDetail != "") {
            return (
                <>
                    {funnelQuery.data.data.segment_list.map(x => x.id == event.data.value.api.funnelDetail ? <h6>{x.segment_name} Funnel is Setted</h6> : "")}
                    <select className="form-select" onChange={(e) => FunnelSet(e.target.value)}>
                        <option value="" disabled selected>Select Funnel</option>
                        {funnelQuery.data.data.segment_list.map(x => <option value={x.id} selected={x.id == event.data.value.api.funnelDetail}>{x.segment_name}</option>)}
                    </select>
                    <FunnelNumberCol apiStrut={event.data.value.api} />
                </>
            )
        } else {
            return (
                <>
                    <select className="form-select" onChange={(e) => FunnelSet(e.target.value)}>
                        <option value="" disabled selected>Select Funnel</option>
                        {funnelQuery.data.data.segment_list.map(x => <option value={x.id}>{x.segment_name}</option>)}
                    </select>
                </>
            )
        }
    }

    return (
        <div className="card-body mt-0 ">
            <div className="contact_add_div">
                <div className="mx-auto">
                    <MainFun />
                </div>
            </div>
        </div>
    )
}